export class TouchedData {
  constructor(initial) {
    this.initial = initial
  }

  isChanged(currentData) {
    return !(JSON.stringify(currentData) === JSON.stringify(this.initial))
  }
}
